import AboutTeamSection from "./AboutTeam";
import AboutBodySection from "./AboutBody";
import HeroSection from "./AboutHero";

const AboutWrapper = () => {
  return (
    <main className="relative w-full overflow-hidden">

      {/* Medical textured background */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-medical-texture opacity-[0.35]"
      />

      {/* Page container */}
      <div
        className="
          relative mx-auto max-w-[1440px]
          px-4 sm:px-6 lg:px-12
          pt-20 sm:pt-24 lg:pt-32
          pb-20 sm:pb-24 lg:pb-32
        "
      >
        {/* Sections with controlled spacing */}
        <div className="space-y-12 sm:space-y-16 lg:space-y-20">
          <HeroSection />
          <AboutBodySection />
          <AboutTeamSection />
        </div>
      </div>

    </main>
  );
};

export default AboutWrapper;
